export default "__VITE_ASSET__DDxvh89F__"